<template>
  <div>
    <v-card class="mx-auto mb-5">
      <v-card-text class="pa-5 black--text">
        <v-container>
          <div class="black--text">
            <h3>Laporan Pendampingan Kelompok</h3>
            <v-list>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="blue">
                          <v-icon dark>mdi-google-classroom</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 px-1">
                          <div class="blue--text body-1">
                            {{ lokakaryaKegiatan[kKegiatan] && lokakaryaKegiatan[kKegiatan][0] }}
                          </div>
                          <div class="black--text body-2">
                            {{ lokakaryaKegiatan[kKegiatan] && lokakaryaKegiatan[kKegiatan][1] }}
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-list-item :class="['px-0', pspKpPa.pendampingan_tahun >= 2024 ? 'ml-6' : '']">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Status Laporan</small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <v-chip
                              :color="
                                !Object.keys(lokakarya || {}).includes('is_terlaksana')
                                  ? 'grey white--text'
                                  : lokakarya.rekap && +lokakarya.rekap.lokakarya === 1
                                  ? +lokakarya.is_terlaksana === 1
                                    ? 'green white--text'
                                    : 'grey white--text'
                                  : 'orange white--text'
                              "
                              dark
                            >
                              {{
                                !Object.keys(lokakarya || {}).includes('is_terlaksana')
                                  ? 'Belum ada'
                                  : lokakarya.rekap && +lokakarya.rekap.lokakarya === 1
                                  ? +lokakarya.is_terlaksana === 1
                                    ? 'Lengkap'
                                    : 'Tidak memfasilitasi'
                                  : 'Belum Lengkap'
                              }}
                            </v-chip>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="3" class="my-auto">
                      <div :class="[pspKpPa.pendampingan_tahun >= 2024 ? 'ml-6' : '']">
                        <v-btn v-if="isEdit" color="primary" class="white--text text-capitalize" @click="onEdit">
                          <v-icon left>mdi-pencil</v-icon> Lengkapi Laporan
                        </v-btn>
                        <v-btn v-else class="text-capitalize" color="primary" @click="onEdit">
                          <v-icon left>mdi-eye</v-icon>Lihat Laporan
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card class="mx-auto" v-if="isTerlaksana">
      <v-card-text>
        <v-container>
          <div class="black--text">
            <h3>Laporan Penilaian {{ +pspKpPa.pendampingan_tahun >= 2024 ? 'Rencana Aksi' : 'Lokakarya' }}</h3>
          </div>
          <div v-if="+pspKpPa.pendampingan_tahun >= 2024" class="mt-3">
            <v-list>
              <div v-for="(sekolah, idSekolah) in sekolahs" :key="idSekolah">
                <v-divider v-if="idSekolah > 0" class="mt-2 mb-3" />
                <v-list-item class="px-0">
                  <v-list-item-avatar color="blue">
                    <v-icon dark>mdi-office-building-outline</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="px-1">
                    <v-row>
                      <v-col cols="12" lg="6">
                        <div class="blue--text body-1">
                          {{ $getDeepObj(sekolah, 'nama') || '-' }}
                        </div>
                        <div class="black--text body-2">
                          <span class="font-weight-medium">NPSN : </span>
                          {{ $getDeepObj(sekolah, 'npsn') || '-' }}
                        </div>
                      </v-col>
                      <v-col cols="12" lg="3">
                        <v-label color="caption"><small>Status Laporan</small></v-label>
                        <div>
                          <v-chip
                            :color="
                              +$getDeepObj(lokakaryaNyata, `${sekolah.sekolah_id}.is_lengkap`) === 1
                                ? 'green'
                                : 'orange'
                            "
                            dark
                          >
                            {{
                              +$getDeepObj(lokakaryaNyata, `${sekolah.sekolah_id}.is_lengkap`) === 1
                                ? 'Lengkap'
                                : 'Belum'
                            }}
                          </v-chip>
                        </div>
                      </v-col>
                      <v-col cols="12" lg="3">
                        <v-btn
                          color="primary"
                          depressed
                          class="ml-3 text-capitalize"
                          @click="onEditNyata(laporanRencana[0], sekolah)"
                        >
                          <template v-if="isEdit">
                            <v-icon left class="mr-2">
                              mdi-pencil
                            </v-icon>
                            Lengkapi Laporan
                          </template>
                          <template v-else>
                            <v-icon left class="mr-2">
                              mdi-eye
                            </v-icon>
                            Lihat Laporan
                          </template>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </v-list>
          </div>
          <div v-else>
            <v-expansion-panels flat class="my-2" accordion v-model="panel">
              <v-expansion-panel v-for="(sekolah, idSekolah) in sekolahs" :key="idSekolah">
                <v-expansion-panel-header class="pa-0">
                  <template v-slot:default="{ open }">
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-list-item class="px-0">
                              <v-list-item-avatar color="blue">
                                <v-icon dark>mdi-office-building-outline</v-icon>
                              </v-list-item-avatar>
                              <v-list-item-content class="py-0 px-1">
                                <div class="blue--text">
                                  {{ $getDeepObj(sekolah, 'nama') || '-' }}
                                </div>
                                <div class="black--text body-2">
                                  <span class="font-weight-medium">NPSN : </span>
                                  {{ $getDeepObj(sekolah, 'npsn') || '-' }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-list-item class="px-0">
                              <v-list-item-content class="py-0 ml-3">
                                <v-list-item-title>
                                  <v-label color="caption"><small>Status Laporan</small></v-label>
                                </v-list-item-title>
                                <v-list-item-subtitle class="link black--text body-2">
                                  <v-chip
                                    :color="
                                      +$getDeepObj(lokakaryaNyata, `${sekolah.sekolah_id}.is_lengkap`) === 1
                                        ? 'green'
                                        : 'orange'
                                    "
                                    dark
                                  >
                                    {{
                                      +$getDeepObj(lokakaryaNyata, `${sekolah.sekolah_id}.is_lengkap`) === 1
                                        ? 'Lengkap'
                                        : 'Belum'
                                    }}
                                  </v-chip>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-list-item class="px-0">
                              <v-list-item-content class="py-0 ml-3">
                                <v-list-item-title class="blue--text">
                                  {{ open ? 'Tampilkan Ringkas' : 'Tampilkan Laporan' }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="orange lighten-5">
                  <v-list class="orange lighten-5">
                    <v-list-item>
                      <v-list-item-content>
                        <v-row>
                          <v-col cols="12" class="my-auto">
                            <div style="font-size: 17px" class="blue--text text--darken-2">
                              <strong>Rencana</strong> Aksi Nyata
                            </div>
                            <div class="caption grey--text">
                              <em>
                                Silahkan melengkapi laporan berikut
                              </em>
                            </div>
                          </v-col>
                        </v-row>
                        <v-list class="orange lighten-5 py-0">
                          <v-list-item
                            v-for="(laporan, idLaporan) in laporanRencana"
                            :key="`rencana-${idLaporan}`"
                            class="px-0"
                          >
                            <v-list-item-content>
                              <v-row>
                                <v-col cols="12" lg="6" class="my-auto">
                                  <span class="body-1 indigo--text ml-3">{{ laporan.keterangan }}</span>
                                </v-col>
                                <v-col cols="12" lg="3" class="my-auto">
                                  <div class="body-2 grey--text">
                                    <v-label color="caption"><small>Status Laporan</small></v-label>
                                  </div>
                                  <v-chip
                                    class="white--text"
                                    :color="
                                      getStatusLaporanNyata(sekolah.sekolah_id, laporan.k_lokakarya_nyata_psp)['color']
                                    "
                                  >
                                    {{
                                      getStatusLaporanNyata(sekolah.sekolah_id, laporan.k_lokakarya_nyata_psp)['label']
                                    }}
                                  </v-chip>
                                </v-col>
                                <v-col cols="12" lg="3" class="my-auto">
                                  <div class="orange--text text--lighten-5">Aksi</div>
                                  <v-btn
                                    color="primary"
                                    depressed
                                    class="ml-3 text-capitalize"
                                    @click="onEditNyata(laporan, sekolah)"
                                  >
                                    <template v-if="isEdit">
                                      <v-icon left class="mr-2">
                                        mdi-pencil
                                      </v-icon>
                                      Lengkapi Laporan
                                    </template>
                                    <template v-else>
                                      <v-icon left class="mr-2">
                                        mdi-eye
                                      </v-icon>
                                      Lihat Laporan
                                    </template>
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <v-divider class="my-4 mx-4" />
                  <v-list class="orange lighten-5">
                    <v-list-item>
                      <v-list-item-content>
                        <v-row>
                          <v-col cols="12" class="my-auto">
                            <div style="font-size: 17px" class="blue--text text--darken-2">
                              <strong>Cerita</strong> Aksi Nyata
                            </div>
                            <div class="caption grey--text">
                              <em>
                                Silahkan melengkapi laporan berikut
                              </em>
                            </div>
                          </v-col>
                        </v-row>
                        <v-list class="orange lighten-5 py-0">
                          <v-list-item
                            v-for="(laporan, idLaporan) in laporanCerita"
                            :key="`cerita-${idLaporan}`"
                            class="px-0"
                          >
                            <v-list-item-content>
                              <v-row>
                                <v-col cols="12" lg="6" class="my-auto">
                                  <span class="body-1 indigo--text ml-3">{{ laporan.keterangan }}</span>
                                </v-col>
                                <v-col cols="12" lg="3" class="my-auto">
                                  <div class="body-2 grey--text">
                                    <v-label color="caption"><small>Status Laporan</small></v-label>
                                  </div>
                                  <v-chip
                                    class="white--text"
                                    :color="
                                      getStatusLaporanNyata(sekolah.sekolah_id, laporan.k_lokakarya_nyata_psp)['color']
                                    "
                                  >
                                    {{
                                      getStatusLaporanNyata(sekolah.sekolah_id, laporan.k_lokakarya_nyata_psp)['label']
                                    }}
                                  </v-chip>
                                </v-col>
                                <v-col cols="12" lg="3" class="my-auto">
                                  <div class="orange--text text--lighten-5">Aksi</div>
                                  <v-btn
                                    color="primary"
                                    depressed
                                    class="ml-3 text-capitalize"
                                    @click="onEditNyata(laporan, sekolah)"
                                  >
                                    <template v-if="isEdit">
                                      <v-icon left class="mr-2">
                                        mdi-pencil
                                      </v-icon>
                                      Lengkapi Laporan
                                    </template>
                                    <template v-else>
                                      <v-icon left class="mr-2">
                                        mdi-eye
                                      </v-icon>
                                      Lihat Laporan
                                    </template>
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
    <base-modal-full ref="modal" :useSave="formulir.useSave" :title="formulir.title" @save="onSave">
      <component
        ref="formulir"
        :is="formulir.component"
        :initValue="formulir.init || {}"
        :kKegiatan="formulir.k_kegiatan || ''"
        :isEdit="formulir.isEdit"
        :readOnly="formulir.readOnly"
        :masters="masters"
        :detail="formulir.component === 'FormKpPaLokakarya' ? detail.lokakarya || {} : formulir.detail || {}"
        :sub-title="formulir.subtitle"
        :key-instrumen="formulir.keyInstrumen"
        :meta="meta"
        :lokakarya="lokakarya"
        @refresh="$emit('refresh')"
      />
    </base-modal-full>
  </div>
</template>
<script>
import FormKpPaLokakarya from '../form/KpPaLokakarya';
import FormKpPaLokakaryaNyata from '../form/KpPaLokakaryaNyata';
import { mapActions } from 'vuex';

export default {
  components: { FormKpPaLokakarya, FormKpPaLokakaryaNyata },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    meta: {
      type: Object,
      default: () => {},
    },
    kKegiatan: {
      type: [Number, String],
      default: '',
    },
    masters: {
      type: Object,
      default: () => {},
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    keyInstrumen: {
      type: String,
      default: '',
    },
  },
  computed: {
    lokakarya() {
      return this.detail.lokakarya || {};
    },

    lokakaryaMeta() {
      return this.detail.meta || {};
    },

    isTerlaksana() {
      return Object.keys(this.lokakarya || {}).includes('is_terlaksana') && +this.lokakarya['is_terlaksana'] === 1;
    },

    lokakaryaKegiatan() {
      return this.meta.lokakarya_kegiatan || {};
    },

    lokakaryaNyata() {
      const pspKpPaLokakaryaNyatas = this.$getDeepObj(this.lokakarya, 'psp_kp_pa_lokakarya_nyatas') || [];
      return this.$arrToObj(pspKpPaLokakaryaNyatas, 'sekolah_id');
    },

    sekolahs() {
      return this.lokakaryaMeta.pendampingan || [];
    },

    laporanRencana() {
      return (this.lokakaryaMeta.nyata || []).filter((laporan) => +laporan.is_cerita !== 1);
    },

    laporanCerita() {
      return (this.lokakaryaMeta.nyata || []).filter((laporan) => +laporan.is_cerita === 1);
    },

    pspKpPa() {
      return this.lokakarya.psp_kp_pa || {};
    },
  },
  data() {
    return {
      panel: null,
      formulir: {},
    };
  },
  methods: {
    ...mapActions('lokakaryaPa', ['getInstrumen', 'update', 'updateNyata']),

    getStatusLaporanNyata(sekolahId, kLokakaryaNyata) {
      const laporanNyata = this.lokakaryaNyata[sekolahId] || {};
      const rekapLaporanNyata = laporanNyata.rekap || {};

      if (Object.keys(rekapLaporanNyata).includes((kLokakaryaNyata || '').toString())) {
        if (+rekapLaporanNyata[kLokakaryaNyata] === 1) {
          return { label: 'Lengkap', color: 'green' };
        }

        return { label: 'Belum lengkap', color: 'orange' };
      }

      return { label: 'Belum ada', color: 'grey' };
    },

    async onEdit() {
      const readOnly = !this.isEdit;
      const kpPas = this.meta.kp_pa || [];
      const id = kpPas[0] && kpPas[0]['psp_kp_pa_id'];

      this.$set(this.formulir, 'id', id);
      this.$set(this.formulir, 'k_kegiatan', this.kKegiatan);
      this.$set(this.formulir, 'init', null);

      const keyInstrumen = this.$getDeepObj(this.meta, `lokakarya_kegiatan.${this.kKegiatan}.5`);
      await this.getInstrumen({ masters: keyInstrumen });

      this.$set(this.formulir, 'title', 'Laporan Pendampingan Kelompok');
      this.$set(this.formulir, 'component', 'FormKpPaLokakarya');
      this.$set(this.formulir, 'isEdit', this.isEdit);
      this.$set(this.formulir, 'detail', this.lokakarya);
      this.$set(this.formulir, 'useSave', !readOnly);
      this.$set(this.formulir, 'readOnly', readOnly);
      this.$set(this.formulir, 'keyInstrumen', this.keyInstrumen);

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', this.lokakarya);
      });
    },

    async onEditNyata(laporan, sekolah) {
      const readOnly = !this.isEdit;
      const kpPas = this.meta.kp_pa || [];
      const id = kpPas[0] && kpPas[0]['psp_kp_pa_id'];

      const lokakaryaNyataSekolah = this.lokakaryaNyata[sekolah.sekolah_id] || {};
      const lokakaryaNyataSekolahInstrumens = lokakaryaNyataSekolah.psp_kp_pa_lokakarya_nyata_instrumens || [];
      const initInstrumen = lokakaryaNyataSekolahInstrumens.filter(
        (instrumen) => +instrumen.k_lokakarya_nyata_psp === +laporan.k_lokakarya_nyata_psp
      );

      await this.getInstrumen({ masters: laporan.master_instrumen });

      this.$set(this.formulir, 'id', id);
      this.$set(this.formulir, 'init', null);
      this.$set(
        this.formulir,
        'title',
        `Form Penilaian ${this.pspKpPa.pendampingan_tahun >= 2024 ? 'Rencana Aksi' : 'Lokakarya'}`
      );
      this.$set(this.formulir, 'component', 'FormKpPaLokakaryaNyata');
      this.$set(this.formulir, 'isEdit', this.isEdit);
      this.$set(this.formulir, 'detail', Object.assign({}, lokakaryaNyataSekolah, { sekolah }));
      this.$set(this.formulir, 'useSave', !readOnly);
      this.$set(this.formulir, 'readOnly', readOnly);
      this.$set(this.formulir, 'subtitle', +laporan.is_cerita === 1 ? 'Cerita' : 'Rencana');
      this.$set(this.formulir, 'keyInstrumen', laporan.master_instrumen);
      this.$set(this.formulir, 'params', {
        sekolah_id: sekolah.sekolah_id,
        k_lokakarya_kegiatan_psp: this.lokakarya.k_lokakarya_kegiatan_psp,
        k_lokakarya_nyata_psp: laporan.k_lokakarya_nyata_psp,
      });

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', { instrumen: initInstrumen });
      });
    },

    onSave() {
      const params = this.$refs.formulir.getValue();
      const id = this.formulir.id;

      if (this.formulir.component === 'FormKpPaLokakaryaNyata') {
        this.onSaveNyata();
        return;
      }

      this.update({ id: id, params: params })
        .then(() => {
          this.$success(`Laporan pendampingan kelompok berhasil diperbarui`);
          this.$emit('refresh');
          this.$refs.modal.close();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onSaveNyata() {
      const params = this.$refs.formulir.getValue();
      const requiredParams = this.formulir.params || {};
      const id = this.formulir.id;

      this.updateNyata({ id: id, params: Object.assign({}, requiredParams, params) })
        .then(() => {
          this.$success(`Laporan pendampingan kelompok berhasil diperbarui`);
          this.$emit('refresh');
          this.$refs.modal.close();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
};
</script>
